import { Progress } from "antd";
import "./ProgressBar.scss";

interface ProgressBarProps {
  value: number;
  strokeWidth?: number;
  title?: string;
  color?: any;
  titleClass?: string;
  format?: (value?: number) => string;
  trailColor?: string;
}

const ProgressBar: React.FC<ProgressBarProps> = (props) => {
  const {
    value,
    strokeWidth,
    title,
    color,
    titleClass = "",
    trailColor = "#f5f5f521",
    format,
  } = props;
  return (
    <div className="progress-bar">
      <span className={titleClass}> {title}</span>
      <Progress
        percent={value}
        strokeColor={color}
        strokeWidth={strokeWidth}
        status="active"
        format={format ? format : (percent) => <>{percent}</>}
        trailColor={trailColor}
      />
    </div>
  );
};

export default ProgressBar;
